import React, { useState, useEffect } from "react";
import { CompletePieIcon, DessertIcon } from "../../Icons";
import LogoPeach from "../../../assets/images/logo/adb.png";
import "./styles.scss";
import Tabs from "../../Navigation/Tabs";

const tabs = [
  {
    label: "Tortas inteiras",
    icon: <CompletePieIcon />,
    id: "tortasinteiras",
  },
  // {
  //   label: "Fatias de torta",
  //   icon: <PieIcon />,
  //   id: "fatiasdetorta",
  // },
  {
    label: "Sobremesas",
    icon: <DessertIcon />,
    id: "sobremesas",
  },
];

const Header = ({ onItemSelected = () => {} }) => {
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentPosition = window.scrollY;
      setIsAtTop(currentPosition < 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header ${isAtTop ? "expanded" : "contracted"}`}>
      <div className="flex items-center justify-center pt-10">
        <img src={LogoPeach} alt="Amor De Bia" />
      </div>

      <div className="header__tabs flex flex-col gap-5">
        <label>Cardápio</label>
        <Tabs tabs={tabs} visibleTabs={3} onSelected={onItemSelected} />
      </div>
    </header>
  );
};

export default Header;
